import script from "./image-template.vue?vue&type=script&lang=ts&setup=true"
export * from "./image-template.vue?vue&type=script&lang=ts&setup=true"

import "./image-template.vue?vue&type=style&index=0&id=292e5e52&lang=scss"

const __exports__ = script;

export default __exports__